import { useMemo } from 'react';
import { useBasket } from '~/features/basket';
import { useProduct } from '~/shared/utils/product';

/**
 * Retrieve current active ids, product is prioritized over
 * basket
 */
export const useObjectIds = () => {
    const { data: product } = useProduct();
    const { data: basket } = useBasket();

    const objectIds = useMemo(() => {
        if (product?.productColorId) {
            return [product.productColorId];
        }

        if (basket?.lines?.length) {
            return basket.lines.map(({ productColorId }) => productColorId || '');
        }

        return [''];
    }, [basket?.lines, product?.productColorId]);

    return objectIds;
};
